import { FC, useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { PageUrlMeta } from 'src/utils/getPageUrlMeta';
import { SidebarButtonWithArrow } from '../SidebarButtonWithArrow';
import { SourceLanguageDropdownOptions } from '../SourceLanguageDropdownOptions';
import { msgs } from '../messages';

type SidebarSourceLanguageDropdownProps = {
  alternateLinks: PageUrlMeta['alternateLinks'];
  onSelect: () => void;
};

export const SidebarSourceLanguageDropdown: FC<SidebarSourceLanguageDropdownProps> = ({
  alternateLinks,
  onSelect,
}) => {
  const intl = useIntl();

  const [isOpen, setIsOpen] = useState(false);

  const close = useCallback(() => setIsOpen(false), []);

  const select = useCallback(() => {
    close();
    onSelect();
  }, [close, onSelect]);

  const toggle = useCallback(() => setIsOpen(o => !o), []);

  return (
    <>
      <SidebarButtonWithArrow data-testid="sidebarSourceLanguageDropdownLabel" onClick={toggle}>
        {intl.formatMessage(msgs.selectPageLanguage)}
      </SidebarButtonWithArrow>

      {isOpen && (
        <SourceLanguageDropdownOptions alternateLinks={alternateLinks} onSelect={select} />
      )}
    </>
  );
};
